import { HttpClient } from '@adapters/HttpClient';
import type { ReadyToPrepareByHourQuery, ReadyToPrepareByHourResponse } from '../models';

export class ReadyToPrepareByHourApiAdapter {
  constructor(private httpClient: HttpClient) {}

  async getReport(params: ReadyToPrepareByHourQuery): Promise<ReadyToPrepareByHourResponse> {
    return this.httpClient.get<ReadyToPrepareByHourResponse>('/report/ready-to-prepare-by-hour', {
      date_from: params.date_from,
      date_to: params.date_to,
    });
  }
}
